import React, { Component } from 'react';
import { Feature } from './sections/Feature';
import About from "./sections/About";
import Contact from "./sections/Contact";
import Banner from "./sections/Banner";
import ReactGA from "react-ga";

class HomePage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {

		ReactGA.pageview(window.location.pathname + window.location.search);

		return (
			<main>
				<Banner />
				<About />
				<Feature />
				{/*<Tournament />*/}
				<Contact />
			</main>
		)
	}
}

export default HomePage;
